export var createStyleElement = function createStyleElement(content) {
  var styleElement = document.createElement('style');
  styleElement.setAttribute('data-name', 'newbuilding-map-runtime-styles');
  styleElement.setAttribute('type', 'text/css');
  styleElement.innerHTML = content;
  return styleElement;
};